<script setup lang="ts">
import { ref } from 'vue'

interface Props {
  name?: string
  label?: string
  multiple?: boolean
  accept?: string
  required?: boolean
  errorMessage?: string
  disabled?: boolean
}

withDefaults(defineProps<Props>(), {
  name: undefined,
  label: 'Pièces jointes',
  multiple: true,
  accept: undefined,
  required: false,
  errorMessage: undefined,
  disabled: false,
})

const emit = defineEmits<{
  change: [files: FileList | null]
}>()

const fileInputRef = ref<HTMLInputElement | null>(null)

const handleFileChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  emit('change', target.files)
}

// Exposer la référence pour permettre l'accès depuis le parent
defineExpose({
  fileInputRef,
})
</script>

<template>
  <div>
    <label class="form-control w-full">
      <div v-if="label" class="label">
        <span class="label-text font-semibold">
          {{ label }}
          <span v-if="required" class="text-red-500">*</span>
        </span>
      </div>
      <div>
        <input
          ref="fileInputRef"
          :name="name"
          class="file-input file-input-sm"
          :class="{ 'border-red-500': errorMessage }"
          type="file"
          :multiple="multiple"
          :accept="accept"
          :required="required"
          :disabled="disabled"
          @change="handleFileChange"
        />
      </div>
      <div v-if="errorMessage" class="label">
        <span class="label-text-alt text-red-500">{{ errorMessage }}</span>
      </div>
    </label>
  </div>
</template>

